import React from 'react';
import { motion } from 'framer-motion';
import { LOCATION_LIST } from '../data/locations';

// Стъпка 1 от резервацията: избор на салон. Преди избор — две големи карти;
// след избор — компактни табове за бърза смяна.
function LocationPicker({ selected, onSelect }) {
  if (selected) {
    return (
      <div className="max-w-6xl mx-auto px-4 pt-4">
        <div className="flex flex-wrap justify-center gap-3" role="tablist" aria-label="Избор на салон">
          {LOCATION_LIST.map((location) => {
            const isActive = location.id === selected;
            return (
              <button
                key={location.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => onSelect(location.id)}
                className={`px-4 py-2 rounded-full text-lg font-semibold whitespace-nowrap transition duration-300 border border-red-800 ${
                  isActive
                    ? 'bg-red-800 text-neutral-100 shadow-lg'
                    : 'bg-red-800 bg-opacity-10 text-red-800 hover:bg-opacity-30'
                }`}
              >
                {location.shortName}
                {location.isNew && (
                  <span className={`ml-2 text-xs font-bold uppercase tracking-wider ${isActive ? 'text-neutral-100' : 'text-red-800'}`}>
                    ново
                  </span>
                )}
              </button>
            );
          })}
        </div>
        {(() => {
          const location = LOCATION_LIST.find((l) => l.id === selected);
          return (
            <p className="text-center text-neutral-700 mt-2">
              {location?.name} · {location?.address} ·{' '}
              <a href={location?.phoneLink} className="underline hover:text-red-900 whitespace-nowrap">
                {location?.phoneDisplay}
              </a>
            </p>
          );
        })()}
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 pt-6">
      <h3 className="text-center text-3xl text-red-800 pb-4">Избери салон</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {LOCATION_LIST.map((location, index) => (
          <motion.button
            key={location.id}
            type="button"
            onClick={() => onSelect(location.id)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            className="group relative text-left bg-neutral-100 border border-red-800 rounded-xl overflow-hidden shadow-lg transform transition duration-300 hover:scale-[1.02] hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-red-400"
          >
            {location.isNew && (
              <span className="absolute top-3 right-3 z-10 bg-red-800 text-neutral-100 text-sm font-bold uppercase tracking-widest rounded-full px-3 py-1 shadow">
                Ново
              </span>
            )}
            <img
              src={location.image}
              alt={`Салон ${location.shortName}`}
              className={`w-full aspect-[3/2] object-cover ${location.imagePosition} grayscale group-hover:grayscale-0 transition duration-500`}
            />
            <div className="p-4">
              <p className="text-2xl font-bold text-red-800">{location.name}</p>
              <p className="text-lg text-neutral-700 mt-1">{location.address}</p>
              <p className="text-lg text-neutral-700">
                Тел.:{' '}
                <span className="font-semibold whitespace-nowrap">{location.phoneDisplay}</span>
              </p>
              <span className="inline-block mt-3 bg-red-800 text-neutral-100 text-lg rounded-lg px-5 py-2 shadow group-hover:bg-red-700 transition duration-300">
                Резервирай тук
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}

export default LocationPicker;
